import React from 'react';
import Container from 'reactstrap/lib/Container';
import Form from 'reactstrap/lib/Form';
import FormGroup from 'reactstrap/lib/FormGroup';
import Input from 'reactstrap/lib/Input';
import Label from 'reactstrap/lib/Label';
import axios from 'axios';
import Swal from 'sweetalert2';

import {BASE_URL, validUsernameRegex} from '../../utils/const';

import './Login.scss';
import Logo from './img/logoRms.svg';
import eye from './img/eye.svg';
import eyeOff from './img/eye-off.svg';

import {getLanguage, t} from 'react-switch-lang';
import {onLogRedirectTo} from '../../services/onLogRedirectTo';

const validateForm = (errors) => {
  let valid = true;
  Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
  return valid;
};

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      username: null,
      password: null,
      type: 'password',
      typeSrc: eye,
      isSubmitted: false,
      // isChecked: true,
      // timer: new Date(),
      errors: {
        username: '',
        password: '',
      },
    };
    this.handleSubmitLogin = this.handleSubmitLogin.bind(this.state);
    this.showHide = this.showHide.bind(this);
  }

  showHide = () => {
    this.setState({
      type: this.state.type === 'password' ? 'text' : 'password',
      typeSrc: this.state.type === 'password' ? eyeOff : eye,
    });
  };

  handleChangeLogin = (event) => {
    event.preventDefault();
    const {name, value} = event.target;
    const errors = this.state.errors;

    switch (name) {
      case 'username':
        errors.username = validUsernameRegex.test(value.trim())
          ? value.length === 0
            ? `${t('login.usernameRequired')}`
            : value.trim().length > 50
              ? `${t('login.usernameMax50')}`
              : ''
          : `${t('login.usernameInvalid')}`;
        break;
      case 'password':
        errors.password =
          value.trim().length < 4
            ? `${t('login.passwordMin4')}`
            : value.length > 30
              ? `${t('login.passwordMax30')}`
              : '';
        break;
      default:
        break;
    }
    this.setState({errors, [name]: value});
  };

  setUserData = (token) => {
    axios({
      method: 'GET',
      url: `${BASE_URL}/account`,
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json',
      },
    })
      .then((r) => {
        const lang = getLanguage();
        if (lang === null || lang === '' || lang === undefined) {
          localStorage.setItem('language_risk', r.data.langKey);
        } else {
          localStorage.setItem('language_risk', lang);
        }
        onLogRedirectTo();
      })
      .catch((r) => {
        if (r.username === undefined) {
        }
        Swal.fire({
          text: `${t('message.errorApi')}`,
          icon: 'error',
          confirmButtonText: 'OK',
        });
      });
  };

  userInfo = (token) => {
    if (token !== null) {
      axios({
        method: 'GET',
        url: `${BASE_URL}/authenticate`,
        headers: {
          Authorization: 'Bearer ' + token,
          Accept: 'application/json',
        },
      })
        .then((r) => {
          this.setUserData(token);
        })
        .catch((r) => {
          Swal.fire({
            text: `${t('message.errorApi')}`,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        });
    }
  };

  handleSubmitLogin = (event) => {
    event.preventDefault();
    this.setState({isSubmitted: true});
    if (
      validateForm(this.state.errors) &&
      this.state.username !== null &&
      this.state.password !== null
    ) {
      const form = {
        username: this.state.username,
        password: this.state.password,
      };
      this.setState({isSubmitting: true});
      axios({
        method: 'POST',
        url: `${BASE_URL}/authenticate`,
        data: JSON.stringify(form),
        headers: {
          Authorization: 'Bearer ',
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => {
          const token = r.data.id_token;
          const webSocket_token_risk = r.data.webSocket_token_risk;
          const isChecked = this.state.isChecked;
          localStorage.setItem('jwt-token-risk', token);
          localStorage.setItem('webSocket_token_risk', webSocket_token_risk);
          this.userInfo(token);
        })
        .catch((r) => {
          if (r.message === 'Network Error') {
            Swal.fire({
              text: `${t('message.errorServerTitle')}`,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
          if (r.response && r.response.status === 401) {
            Swal.fire({
              text: `${t('login.incorrect')}`,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          } else if (r.response) {
            Swal.fire({
              text: `${t('message.errorApi')}`,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        });
    } else {
      Swal.fire({
        text: `${t('login.required')}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  render() {
    const errors = this.state.errors;
    return (
      <>
        {localStorage.getItem('jwt-token-risk') &&
        this.props.location.pathname !== '/login' ? (
          <>{onLogRedirectTo(this.props.resourceData)}</>
        ) : (
          <div className='login_wrapp'>
            <div className='left'></div>
            <div className='right'>
              <Container>
                <div className='wrapp'>
                  <img className='header-img' src={Logo}></img>
                  {/*<h4 className='login-title'>Risk Management System</h4>*/}
                  <p className='welcome-p'>{t('login.welcome-label')}</p>
                  <Form onSubmit={this.handleSubmitLogin} noValidate>
                    <FormGroup className='form-group'>
                      <Label htmlFor='username'>{t('login.username')}</Label>
                      <Input
                        name='username'
                        id='username'
                        className='form-control'
                        onChange={this.handleChangeLogin}
                        noValidate
                        required
                      />

                      {this.state.isSubmitted && errors.username.length > 0 && (
                        <div className='error-message'>{errors.username}</div>
                      )}
                    </FormGroup>
                    <FormGroup className='form-group'>
                      <Label htmlFor='password'>{t('login.password')}</Label>
                      <div className='position-relative-input'>
                        <Input
                          type={this.state.type}
                          name='password'
                          id='password'
                          className='form-control'
                          onChange={this.handleChangeLogin}
                          noValidate
                          required
                        />
                        <img
                          src={this.state.typeSrc}
                          alt='password_show'
                          className='show_hide'
                          onClick={this.showHide}
                        />
                      </div>
                      {this.state.isSubmitted && errors.password.length > 0 && (
                        <div className='error-message'>{errors.password}</div>
                      )}
                    </FormGroup>
                    <span
                      onClick={() => {
                        this.props.history.push('/forgot-password');
                      }}
                      className={'forgot-pass-btn'}
                      id='reset-password-link'>
								{t('login.forgot')}
							</span>
                    <div className='bottom'>
                      <button onClick={this.handleSubmitLogin}>
                        {t('login.login-label')}
                      </button>
                    </div>
                  </Form>
                </div>
              </Container>
            </div>
          </div>
        )}
      </>
    );
  }
}
